import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { publicApi } from "@/lib/api";
import { Reveal } from "@/components/motion/Reveal";

export default function FAQ() {
  const [items, setItems] = useState([]);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    publicApi.faqs().then((r) => {
      setItems(r);
      if (r[0]) setOpenId(r[0].id);
    }).catch(() => setItems([]));
  }, []);

  return (
    <section id="faq" className="relative py-24 md:py-36 border-t border-[#1A1A1A]/10" data-testid="faq-section">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <div className="grid grid-cols-12 gap-6">
          <Reveal className="col-span-12 md:col-span-5">
            <div className="eyebrow mb-6">— 09 · Preguntas</div>
            <h2 className="display-2">Preguntas <em className="italic text-[#1B3B2B]">frecuentes</em>.</h2>
            <p className="mt-6 text-sm text-[#4A4A4A] leading-relaxed max-w-sm">
              Respuestas a las consultas más comunes de organizaciones que evalúan iniciar un proceso de consultoría o certificación.
            </p>
          </Reveal>

          <div className="col-span-12 md:col-span-7 md:pl-6">
            <div className="border-t border-[#1A1A1A]/15">
              {items.map((f, i) => {
                const isOpen = openId === f.id;
                return (
                  <div key={f.id} className="border-b border-[#1A1A1A]/15">
                    <button
                      type="button"
                      onClick={() => setOpenId(isOpen ? null : f.id)}
                      className="w-full py-6 flex items-start justify-between gap-6 text-left"
                      data-testid={`faq-toggle-${i}`}
                    >
                      <span className="flex-1 font-serif text-xl md:text-2xl leading-snug">
                        <span className="text-[#1B3B2B] mr-3 text-sm align-top">{String(i + 1).padStart(2, "0")}</span>
                        {f.pregunta}
                      </span>
                      <span className="mt-1 h-8 w-8 rounded-full border border-[#1A1A1A]/25 flex items-center justify-center shrink-0">
                        {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                      </span>
                    </button>
                    <AnimatePresence initial={false}>
                      {isOpen && (
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: "auto", opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.4, ease: [0.76, 0, 0.24, 1] }}
                          className="overflow-hidden"
                        >
                          <p className="pb-6 pr-16 text-[#4A4A4A] leading-relaxed max-w-2xl" data-testid={`faq-answer-${i}`}>
                            {f.respuesta}
                          </p>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
